module.exports = __webpack_public_path__ + "img/lisatietzsch.c07b8416.jpg";